// extracted by mini-css-extract-plugin
export var filterIncDec = "_4i-0";
export var leftBorder = "_4i-1";
export var rightBorder = "_4i-2";
export var stringInput = "_4i-3";